import React, {useEffect, useState} from 'react'
import {useNavigate} from "react-router-dom";
import {archiveDRoll, getArchivedDRolls, getDRolls, restoreDRoll} from "../services/DRollService";
import plusIcon from "../icons/grey-plus-btn.png";
import {View, ScrollView, StyleSheet, Text, TouchableOpacity, Image, Pressable} from 'react-native-web';
import DRollPreview from './DRollPreview';
import Header from './Header';
import upArrowIcon from "../icons/up-arrow-icon.png";
import Modal from "react-modal";
import blueLandscapeIcon from "../icons/blue-landscape-icon.png";
import Button from "./Button";

const drollTemplate = {
    id: 'template',
    name: 'D-Roll Name',
}

const DRolls = () => {
    const navigate = useNavigate();
    const [drolls, setDRolls] = useState([])
    const [archivedDRolls, setArchivedDRolls] = useState([])
    const [selectedDRoll, setSelectedDRoll] = useState({})
    const [archiveModal, setArchiveModal] = useState(false)
    const [showArchived, setShowArchived] = useState(false)

    useEffect(()=>{
        fetchDRolls();
        retrieveArchivedDRolls();
    }, []);

    function fetchDRolls() {
        getDRolls()
            .then(resp => {
                if (resp.status === 200 && resp.data) {
                    setDRolls(resp.data);
                }
            })
    }

    function openArchiveModal(droll) {
        setSelectedDRoll(droll);
        setArchiveModal(true);
    }

    function closeModal() {
        setArchiveModal(false);
    }

    function afterOpenModal() {

    }

    function toggleShowArchived() {
        setShowArchived(!showArchived);
    }

    function retrieveArchivedDRolls() {
        getArchivedDRolls()
            .then(resp => {
                if (resp && resp.status === 200 && resp.data) {
                    setArchivedDRolls(resp.data);
                }
            })
    }

    function triggerDRollArchive() {
        archiveDRoll(selectedDRoll.id)
            .then(resp => {
                fetchDRolls();
                retrieveArchivedDRolls();
                setArchiveModal(false);
            })
    }

    function triggerDRollRestore(droll) {
        restoreDRoll(droll.id)
            .then(resp => {
                fetchDRolls();
                retrieveArchivedDRolls();
                setArchiveModal(false);
            })
    }

    return(
        <View style={{height: '100vh'}}>
            <Header title="D-Roll"/>
            <View>
                <View style={styles.containerLabelDiv}>
                    <View style={styles.headerContainer}>
                        <Text style={styles.blueText}>Active D-Rolls</Text>
                        <TouchableOpacity onPress={() => navigate('/drolls/create')}>
                            <Image source={plusIcon} style={styles.addDRollImg} />
                        </TouchableOpacity>
                    </View>
                    <Text style={styles.descriptionText}>
                        D-Rolls are public campaigns where anyone can submit content for a set payment per photo/video. Perfect for gathering diverse content from the community.
                    </Text>
                </View>
                {!drolls || drolls.length < 1 ? <DRollPreview droll={drollTemplate} /> :
                <ScrollView>
                    <View>
                        {drolls.map(droll => (
                            <DRollPreview key={droll.id} droll={droll} openArchiveModal={openArchiveModal} />
                        ))}
                    </View>
                    <View style={styles.archivedView}>
                        <Pressable style={{flexDirection: "row", justifyContent: "space-between",}} onPress={toggleShowArchived}>
                            <Text style={styles.redText}>Archived D-Rolls ({archivedDRolls.length})</Text>
                            <Image source={upArrowIcon} style={styles.arrowIcon} />
                        </Pressable>
                        {showArchived && archivedDRolls && archivedDRolls.length > 0 && (
                            <View style={{paddingTop: 15,}}>
                                {archivedDRolls.map(droll => (
                                    <DRollPreview alternateBackground={true} archived={true} key={droll.id} droll={droll} openArchiveModal={openArchiveModal} restore={triggerDRollRestore} />
                                ))}
                            </View>
                            )}
                    </View>
                </ScrollView>
                }
            </View>
            <Modal
                isOpen={archiveModal}
                onAfterOpen={afterOpenModal}
                onRequestClose={closeModal}
                className={"invite-modal"}
                style={styles.modal}
            >
                <View style={{alignItems: 'center', backgroundColor: 'white', borderRadius: 10, padding: 20}}>
                    <Text>Are you sure you want to archive {selectedDRoll.name}?</Text>
                    <Image
                        style={styles.drollPreviewImage}
                        source={selectedDRoll.imageExists
                            ? {uri: 'https://d3p3fw3rutb1if.cloudfront.net/business/photos/' + selectedDRoll.id}
                            : blueLandscapeIcon
                        }
                        defaultSource={blueLandscapeIcon}
                        resizeMode="cover"
                    />
                    <View style={{flexDirection: "row"}}>
                        <Button style={{marginRight: 5}} text={"Cancel"} variant={"secondary"} onPress={() => setArchiveModal(false)} />
                        <Button style={{marginLeft: 5}} text={"Archive"} variant={"warning"} onPress={triggerDRollArchive} />
                    </View>
                </View>
            </Modal>
        </View>
    );
}

const styles = StyleSheet.create({
    containerLabelDiv: {
        marginLeft: '2.5%',
        marginRight: '2.5%',
        marginBottom: 20,
    },
    headerContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    blueText: {
        color: '#396de0',
        fontFamily: "'forma-djr-display', sans-serif",
        fontSize: 18,
        fontWeight: 'bold',
        marginBottom: 10,
        paddingTop: 10,
    },
    descriptionText: {
        fontSize: 14,
        color: '#737373',
        fontFamily: "'lato', sans-serif",
        marginBottom: 0,
    },
    addDRollImg: {
        width: 20,
        height: 20,
        alignSelf: 'flex-start',
    },
    archivedView: {
        backgroundColor: 'white',
        borderRadius: 12,
        padding: 20,
        marginBottom: 16,
        marginLeft: '2.5%',
        marginRight: '2.5%',
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.1,
        shadowRadius: 8,
        elevation: 3,
        borderWidth: 1,
        borderColor: '#e5e7eb',
    },
    arrowIcon: {
        height: 20,
        width: 20,
    },
    redText: {
        color: '#e03939',
        fontFamily: "'lato', sans-serif",
        fontWeight: 'bold',
    },
    modal: {
        overlay: {
            display: 'flex',
            flex: 1,
            justifyContent: 'center',
            alignContent: 'center',
            backgroundColor: 'rgba(57, 109, 224, .5)'
        },
        content: {
            margin: '30%',
            inset: 0,
            background: 'none',
            flex: 1,
            border: 'none',
            alignSelf: 'center',
            alignContent: 'center',
            outline: 'none',
        }
    },
    drollPreviewImage: {
        height: 100,
        width: 100,
        borderRadius: 8,
        marginVertical: 15,
    },
});

export default DRolls; 